const Star = () => (
    <svg
        width='10'
        height='10'
        viewBox='0 0 10 10'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M4.50055 1.0939C4.65022 0.633242 5.30193 0.633241 5.4516 1.0939L6.23864 3.51614C6.30557 3.72215 6.49755 3.86163 6.71416 3.86163L9.26106 3.86163C9.74542 3.86163 9.94681 4.48144 9.55495 4.76614L7.49447 6.26317C7.31923 6.39049 7.2459 6.61617 7.31284 6.82218L8.09987 9.24442C8.24955 9.70508 7.72231 10.0881 7.33045 9.80344L5.26997 8.30641C5.09472 8.17909 4.85743 8.17909 4.68218 8.30641L2.6217 9.80344C2.22984 10.0881 1.7026 9.70508 1.85228 9.24442L2.63931 6.82218C2.70625 6.61617 2.63292 6.39049 2.45768 6.26317L0.397196 4.76614C0.00533879 4.48144 0.206726 3.86163 0.691087 3.86163L3.23798 3.86163C3.4546 3.86163 3.64657 3.72215 3.71351 3.51614L4.50055 1.0939Z'
            fill='#979797'
        />
    </svg>
);

export default Star;
